export const STATS = [
  {
    label: 'Verified\nAstrologers',
    target: 24,
    suffix: '+',
    icon: { polygon: '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2' },
  },
  {
    label: 'Happy\nCustomers',
    target: 300,
    suffix: '+',
    icon: {
      paths: [
        'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z',
      ],
    },
  },
  {
    label: 'Years\nExperience',
    target: 15,
    suffix: '+',
    icon: { circle: { cx: 12, cy: 12, r: 10 }, polylines: [[12, 6, 12, 12, 16, 14]] },
  },
  {
    label: 'Spiritual\nRemedies',
    target: 120,
    suffix: '+',
    icon: { paths: ['M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z'] },
  },
]
